module.exports = __webpack_public_path__ + "img/agent-skill.8d860114.png";